import * as React from "react";
import {useState} from "react";

import "./saveAlerts.scss";

import {cs}       from "@Common/react/chain-services";
import {UseState} from "@Common/react/use-state";

export const SaveAlerts = ({message, onClose}) => {

    return (
        <div className="save-alert-box-9fv">
            <div className={message.success ? "green-box" : "orange-box"}>
                <div className="icon">
                    <div className="middle">
                        <i className={message.success ? "fa fa-check-circle" : "fa fa-exclamation-circle"}/>
                    </div>
                </div>
                <div
                    className="text"
                >
                    <b>{message.heading}</b>
                    {message.message}
                </div>
                <div>
                    <button
                        className="close-modal-btn"
                        xd-qa-type="icon"
                        xd-qa-name="close"
                        hidden={!message.success ? false : true}
                        onClick={() => onClose()}
                    ><i className="fa fa-times"/></button>
                </div>
            </div>
        </div>
    )
}